module.exports = __webpack_public_path__ + "static/media/formacao_professores_top_banner.13cb1693.webp";